"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _wavesurfer = _interopRequireDefault(require("wavesurfer.js")),
    _classnames = _interopRequireDefault(require("classnames")),
    _vars = require("@devsta/ui-kit/dist/common/styles/vars"),
    _InteractiveOverlay = _interopRequireDefault(require("../../InteractiveOverlay")),
    _FileTypeIcon = _interopRequireDefault(require("../../FileTypeIcon"));

require("../styles/_audio-preview.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var WAVE_CONTAINER_CLASS = "audio-preview__wave",
    AudioPreview = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.requiresWaveSurfer = function (a) {
      return function () {
        return d._waveSurfer ? a.apply(void 0, arguments) : null;
      };
    }, d.handleWaveSurferAction = d.requiresWaveSurfer(function (a) {
      d._waveSurfer[a]();
    }), d.componentWillUnmount = d.requiresWaveSurfer(function () {
      d._waveSurfer = null;
    }), d.onPlay = function () {
      d.handleWaveSurferAction("play");
    }, d.onPause = function () {
      d.handleWaveSurferAction("pause");
    }, d.onRestartPreview = function () {
      d.handleWaveSurferAction("stop");
    }, d.getCurrentAudioTime = function () {
      return d.handleWaveSurferAction("getCurrentTime");
    }, d.state = {
      isLoading: !0,
      playing: !1
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var a = this,
          b = this.props.asset.assetFiles,
          c = b.ORIGINAL.sourceUrl,
          d = _wavesurfer["default"].create({
        container: document.querySelector(".".concat(WAVE_CONTAINER_CLASS)),
        waveColor: _vars.COLOURS.grey.athens.bigFat,
        progressColor: _vars.COLOURS.cyan.jungleGreen.monkey,
        responsive: !0,
        backend: "MediaElement",
        barWidth: 2,
        barGap: 0,
        cursorWidth: 2,
        cursorColor: "rgba(0,0,0,0)"
      });

      this._waveSurfer = d, d.load(c), d.on("waveform-ready", this.requiresWaveSurfer(function () {
        a.setState({
          isLoading: !1
        });
      })), d.on("play", this.requiresWaveSurfer(function () {
        a.setState({
          playing: !0
        });
      })), d.on("pause", this.requiresWaveSurfer(function () {
        a.setState({
          playing: !1
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props.hideFileTypeIcon,
          b = this.state,
          c = b.isLoading,
          d = b.playing;
      return _react["default"].createElement(_InteractiveOverlay["default"], {
        onPlay: this.onPlay,
        onPause: this.onPause,
        onRestart: this.onRestartPreview,
        playing: d,
        getCurrentTime: this.getCurrentAudioTime,
        loading: c
      }, function (b) {
        var e = b.overlay,
            f = b.hovering,
            g = b.onMouseOver,
            h = b.onMouseLeave;
        return _react["default"].createElement("div", {
          role: "button",
          className: "audio-preview",
          onMouseOver: g,
          onMouseLeave: h,
          onFocus: g,
          onBlur: h,
          tabIndex: 0
        }, e, _react["default"].createElement("div", {
          className: (0, _classnames["default"])(WAVE_CONTAINER_CLASS, (0, _defineProperty2["default"])({}, "".concat(WAVE_CONTAINER_CLASS, "--is-visible"), !c))
        }), a || d && !f ? null : _react["default"].createElement(_FileTypeIcon["default"], {
          className: "audio-preview__media-icon",
          name: "audio",
          color: "white"
        }));
      });
    }
  }]), b;
}(_react.Component);

exports["default"] = AudioPreview;